// extracted by mini-css-extract-plugin
export default {"media-collection":"media-collection--gwPJ3rEPNl","mediaCollection":"media-collection--gwPJ3rEPNl"};